'use strict';

var fareLadderStyling = require('../services/fareladderstyling.json');
var FareChartDataFactory = function FareChartDataFactory($filter, faresOptimizerFareTooltipService) {
  var FareChartData = function FareChartData() {
    this.x = undefined;
    this.y = undefined;
    this.fareBasisCode = undefined;
    this.rbd = undefined;
    this.yq = undefined;
    this.yr = undefined;
    this.q = undefined;
    this.airportTax = undefined;
    this.variable = undefined;
    this.status = undefined;
    this.rectangleStyle = undefined;
    this.textStyle = undefined;
    this.actionCode = undefined;
    this.isShowIndicator = undefined;
    this.isFillIndicator = undefined;
    this.rectangleIndicatorStyle = undefined;
    this.textIndicatorStyle = undefined;
  };
  FareChartData.prototype.initialize = function (fareData, settings) {
    this.x = 0;
    this.y = 2;
    this.yq = fareData.yq;
    this.yr = fareData.yr;
    this.q = fareData.q;
    this.airportTax = fareData.other;
    this.variable = fareData.variable;
    this.status = fareData.status;
    this.fareRange = settings.fareRange;
    this.rectangleStyle = undefined;
    this.textStyle = undefined;
    this.actionCode = fareData.actionCode;
    this.isShowIndicator = undefined;
    this.isFillIndicator = undefined;
    this.rectangleIndicatorStyle = undefined;
    this.textIndicatorStyle = undefined;
    return this;
  };
  FareChartData.prototype.createFareChartData = function (fareData, settings) {
    this.actionCode = fareData.actionCode;
    switch (settings.type) {
      case 'recommendation':
        this.isShowIndicator = fareData.isMappedRbd;
        this.isFillIndicator = fareData.isMappedRbd && !fareData.isSharedFbc;
        this.rectangleIndicatorStyle = getRectangleStylingByIndicator(fareData.isMappedRbd, fareData.isSharedFbc);
        this.textIndicatorStyle = getTextStylingByIndicator(fareData.isMappedRbd, fareData.isSharedFbc);
        this.fareBasisCode = fareData.fbc;
        this.rbd = fareData.hasLinkedFbc ? fareData.fbc.charAt(0) + '*' : fareData.fbc.charAt(0);
        this.baseFare = settings.showEffectiveFares ? fareData.effectiveBaseFare : fareData.recommendedFareBase;
        this.totalFare = settings.showEffectiveFares ? fareData.effectiveTotalFare : fareData.recommendedFareTotal;
        this.rectangleStyle = getRectangleStylingByActionCode(fareData, getRectangleStylingByStatus(fareData));
        this.textStyle = getTextStylingByActionCode(fareData, getTextStylingByStatus(fareData));
        this.toolTipContent = settings.showEffectiveFares ? faresOptimizerFareTooltipService.getEffectiveFareTooltipDataWithFbc(fareData) : faresOptimizerFareTooltipService.getRecommendedFareTooltipDataWithFbc(fareData);
        break;
      case 'current':
        this.fareBasisCode = fareData.fbc;
        this.rbd = fareData.fbc.charAt(0);
        this.baseFare = fareData.currentFareBase;
        this.totalFare = fareData.currentFareTotal;
        this.rectangleStyle = 'fare-rectangle-current';
        this.textStyle = 'fare-rectangle-text-current';
        break;
      case 'effective':
        this.fareBasisCode = fareData.fbc;
        this.rbd = fareData.fbc.charAt(0);
        this.baseFare = fareData.effectiveBaseFare;
        this.totalFare = fareData.effectiveTotalFare;
        var effectiveFareChanged = hasEffectiveFareChanged(fareData);
        this.rectangleStyle = effectiveFareChanged ? 'fare-rectangle-effective-changed' : 'fare-rectangle-effective';
        this.textStyle = effectiveFareChanged ? 'fare-rectangle-text-effective-changed' : 'fare-rectangle-text-effective';
        break;
      case 'competitor':
        this.isShowIndicator = fareData.isMappedRbd;
        this.isFillIndicator = true;
        this.rectangleIndicatorStyle = getRectangleStylingByIndicator(fareData.isMappedRbd, false);
        this.textIndicatorStyle = getTextStylingByIndicator(fareData.isMappedRbd, fareData.isSharedFbc);
        this.rbd = fareData.fareBasisCode.charAt(0);
        this.totalFare = fareData.totalFare;
        this.fareBasisCode = fareData.fareBasisCode;
        this.rectangleStyle = 'fare-rectangle-competitor';
        this.textStyle = 'fare-rectangle-text-competitor';
        break;
      case 'webfare':
        this.baseFare = fareData.baseFare;
        this.totalFare = fareData.totalFare;
        this.departureDate = fareData.departureDate;
        this.connectionOutbound = fareData.connectionOutbound;
        this.lowestBaseFarePercentage = fareData.lowestBaseFarePercentage;
        this.lowestTotalFarePercentage = fareData.lowestTotalFarePercentage;
        this.toolTipContent = faresOptimizerFareTooltipService.getWebFareTooltipData(fareData);
        this.visible = fareData.visible !== undefined ? fareData.visible : true;
        break;
      default:
        throw new Error('Invalid fare type: ' + settings.type);
    }
    return this;
  };
  function getRectangleStylingByIndicator(isMappedRbd, isSharedFbc) {
    if (isMappedRbd) {
      return isSharedFbc ? 'fare-rectangle-indicator--short' : 'fare-rectangle-indicator';
    }
    return '';
  }
  function getTextStylingByIndicator(isMappedRbd, isSharedFbc) {
    if (isMappedRbd) {
      return isSharedFbc ? '' : 'fare-rectangle-text-indicator';
    }
    return '';
  }
  function getRectangleStylingByStatus(fareData) {
    if (fareData.isSharedFbc) {
      return 'fare-rectangle-shared';
    }
    var style = fareLadderStyling[fareData.status];
    if (style) {
      return style.rectangleStyle;
    }
    return 'fare-rectangle-recommendation';
  }
  function getTextStylingByStatus(fareData) {
    if (fareData.isSharedFbc) {
      return 'fare-rectangle-text-shared';
    }
    var style = fareLadderStyling[fareData.status];
    if (style) {
      return style.textStyle;
    }
    return 'fare-rectangle-text-recommendation';
  }
  function getRectangleStylingByActionCode(fareData, rectangleStyle) {
    if (fareData.actionCode === 'N') {
      return 'fare-rectangle-new';
    } else if (fareData.actionCode === 'X') {
      return 'fare-rectangle-canceled';
    }
    return rectangleStyle;
  }
  function getTextStylingByActionCode(fareData, textStyle) {
    if (fareData.actionCode === 'N') {
      return 'fare-rectangle-text-new';
    } else if (fareData.actionCode === 'X') {
      return 'fare-rectangle-text-canceled';
    }
    return textStyle;
  }
  function hasEffectiveFareChanged(fareData) {
    return Math.round(fareData.recommendedFareTotal) !== Math.round(fareData.effectiveTotalFare);
  }
  return FareChartData;
};
FareChartDataFactory.$inject = ['$filter', 'FaresOptimizerFareTooltipService'];
module.exports = FareChartDataFactory;